import React from "react";
import classnames from 'classnames'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from "react-localize-redux";
import { Formik, Form } from 'formik';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { apiGet, createQs } from "../../../store/apiWrapper";
import { Circles } from '../../common/loadingComponent';
import NoDataComponent from '../../common/noDataComponent';
import NavigationRow from "../../layoutItems/navigationRow";
import BbCheckbox from "../../styling/bbCheckbox";
import BbDatePicker from "../../common/datePicker";
import moment from 'moment';
import RelationsSearchNavigator from "./relationsSearchNavigator";
import RelationsSearchParametersSlider from "./relationsSearchParametersSlider";
import { chartActions } from '../../../store/charts/chartsStore';
import { relationsSearchActions, searchInstances } from '../../../store/relationsSearchStore';

import "../../marketingList/marketingSection.scss";

const LEVEL_MARKS = {
    '1': "1",
    '2': "2",
    '3': "3",
    '4': "4"
}
const TIME_MARKS = {
    '30': "30 s",
    '180': "3 min",
    '330': "5.5 min",
    '480': "8 min"
}
const UNCHECKED_TYPES = {
    'PublicProcurement': "NR08",
    'Creditor': "NR0H"
}

class RelationsSearchParameters extends React.Component {
    prefix = "/search/relations";

    state = {
        isLoading: false,
        relationTypes: []
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.user.language !== prevProps.user.language) {
            this.getData();
        }
    }

    componentWillUnmount() {
        const values = this.formRef.state.values;
        const { mode, ...params } = this.getRelationFilter(values);
        this.props.setRelationsFilter(params);
    }

    getData() {
        if (isNullOrUndefined(this.props.rsa.relationsFilter)) {
            if (!isNullOrUndefined(localStorage.getItem("relationsFilter"))) {
                let relationsFilter = JSON.parse(localStorage.getItem("relationsFilter"));
                this.props.setRelationsFilter(relationsFilter);
                this.setState({ isLoading: false, relationTypes: relationsFilter.relationTypes })
            } else {
                this.setState({ isLoading: true });
                apiGet(`${window.babylonApiUrl}/api/search/relation-types`, null,
                    (response) => {
                        const relationTypes = response.data.map(type => ({ label: type.label, value: type.value, checked: this.isChecked(type.value) }));
                        const initValues = this.getInitialRelationFilter(null, relationTypes);
                        this.props.setRelationsFilter(initValues);
                        this.setState({ isLoading: false, relationTypes: relationTypes })
                    },
                    () => {
                        this.setState({ isLoading: false });
                    }
                );
            }
        } else {
            this.setState({ relationTypes: this.props.rsa.relationsFilter.relationTypes })
        }
    }

    isChecked = (value) => Object.values(UNCHECKED_TYPES).indexOf(value) === -1;

    getInitialRelationFilter(parameters, relationTypes) {
        return ({
            historicalChecked: !isNullOrUndefined(parameters) ? parameters.historicalChecked : false,
            historicalFrom: !isNullOrUndefined(parameters) ? parameters.historicalFrom : '',
            historicalTo: !isNullOrUndefined(parameters) ? parameters.historicalTo : '',
            level: !isNullOrUndefined(parameters) ? parameters.level : 2,
            time: !isNullOrUndefined(parameters) ? parameters.time : 30,
            relationTypes: !isNullOrUndefined(parameters) ? parameters.relationTypes : relationTypes
        })
    }

    getRelationFilter(values) {
        return ({
            historicalChecked: values.historicalChecked,
            historicalFrom: isNullOrUndefined(values.historicalFrom) || values.historicalFrom === "" ? null : moment(values.historicalFrom).format("YYYY-MM-DD"),
            historicalTo: isNullOrUndefined(values.historicalTo) || values.historicalTo === "" ? null : moment(values.historicalTo).format("YYYY-MM-DD"),
            level: values.level,
            time: values.time,
            relationTypes: values.relationTypes,
            mode: 'path'
        });
    }

    render = () => {
        const parameters = this.props.rsa.relationsFilter;
        const initFilter = this.getInitialRelationFilter(parameters, this.state.relationTypes);
        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={initFilter}
            >
                {({ values, setFieldValue }) => (
                    <>
                        <div className="content-root">
                            <RelationsSearchNavigator />
                            {this.renderForm(values, setFieldValue)}
                        </div>

                        <NavigationRow justify={this.canGoBack() ? "space-between" : "flex-end"}>
                            {this.canGoBack() &&
                                <button
                                    className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    type="button"
                                    onClick={() => {
                                        const params = this.getRelationFilter(values);
                                        this.props.setRelationsFilter(params);
                                        this.props.history.push({
                                            pathname: `${this.prefix}`
                                        })
                                    }}
                                >
                                    <Translate id="Search.Relations.BackToSearch" />
                                </button>
                            }
                            <button
                                className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                type="button"
                                disabled={!this.canContinue(values)}
                                onClick={() => this.onSubmit(values)}>
                                <Translate id="Common.Search" />
                            </button>
                        </NavigationRow>
                    </>
                )}
            </Formik>
        );
    }

    renderForm = (values, setFieldValue) => {
        if (this.state.isLoading)
            return <Circles />

        if (isNullOrUndefined(this.state.relationTypes) || this.state.relationTypes.length === 0)
            return (<NoDataComponent />);

        return (
            <Form style={{ width: "100%" }}>
                <div className="card">
                    <div className="card-body">
                        <div className='field bb-field'>
                            <div className="columns">
                                <div className="column is-4 bb-input-label-column">
                                    <div className="bankruptcy-label">
                                        <BbCheckbox
                                            id="historical-relations"
                                            label={this.props.translate("Search.Relations.HistoricalRelations")}
                                            value={values.historicalChecked}
                                            onChange={(value) => {
                                                this.changeValue("historicalChecked", setFieldValue, values, value);
                                            }} />
                                    </div>
                                </div>
                                <div className="column is-4">
                                    <div className="bankruptcy-date">
                                        <BbDatePicker formik={this.formRef} field={'historicalFrom'} value={values.historicalFrom} disabled={!values.historicalChecked}
                                            placeholder={this.props.translate("Report.Common.From")} formDateFormat={"YYYY-MM-DD"} enableReinitialize
                                            yearsBack={120}
                                            afterDateChange={(stringDateTime, isValid) => this.changeValue('historicalFrom', setFieldValue, values, stringDateTime)}
                                        />
                                    </div>
                                </div>
                                <div className="column is-4">
                                    <div className="bankruptcy-date">
                                        <BbDatePicker formik={this.formRef} field={'historicalTo'} value={values.historicalTo} disabled={!values.historicalChecked}
                                            placeholder={this.props.translate("Report.Common.To")} formDateFormat={"YYYY-MM-DD"} enableReinitialize
                                            yearsBack={120}
                                            afterDateChange={(stringDateTime, isValid) => this.changeValue('historicalTo', setFieldValue, values, stringDateTime)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='field bb-field'>
                            <div className="columns">
                                <div className="column is-4 bb-input-label-column">
                                    <div className="bankruptcy-label">
                                        <Translate id="Search.Relations.Level" />
                                    </div>
                                </div>
                                <div className="column is-8">
                                    <RelationsSearchParametersSlider
                                        marks={LEVEL_MARKS}
                                        min={1}
                                        max={4}
                                        value={values.level}
                                        onChange={(value) => this.changeValue('level', setFieldValue, values, value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='field bb-field'>
                            <div className="columns">
                                <div className="column is-4 bb-input-label-column">
                                    <div className="bankruptcy-label">
                                        <Translate id="Search.Relations.ShowResults" />
                                    </div>
                                </div>
                                <div className="column is-8">
                                    <RelationsSearchParametersSlider
                                        marks={TIME_MARKS}
                                        min={30}
                                        max={480}
                                        value={values.time}
                                        onChange={(value) => this.changeValue('time', setFieldValue, values, value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='field bb-field' style={{ paddingTop: '1.5em' }}>
                            <div className="columns">
                                <div className="column is-12">
                                    {this.renderRelationTypes(values, setFieldValue)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }

    renderRelationTypes = (values, setFieldValue) => {
        return (
            <div className="marketing-list-section">
                <div className="header-body relationsSearch-card-header-content">
                    <Translate id="Search.Relations.RelationsTypes" />
                </div>
                <div className='section-body'>
                    <div className="columns is-multiline">
                        <div className="column is-12" style={{ paddingBottom: '0' }}>
                            <div className="bb-chk-grp-all">
                                <BbCheckbox
                                    id="relationsType-all"
                                    label={this.props.translate("Multiselect.CheckAll")}
                                    value={this.isAllChecked(values.relationTypes)}
                                    onChange={(value) => this.checkAll(values.relationTypes, values, value, setFieldValue)} />
                            </div>
                        </div>
                        <div className="column is-6-desktop is-12-tablet" style={{ paddingTop: '0' }}>
                            {values.relationTypes.map((type, index) => {
                                if (index < (values.relationTypes.length / 2)) {
                                    return this.renderRelationTypeCheckBox(values.relationTypes, type, setFieldValue, values)
                                }
                            })}
                        </div>
                        <div className="column is-6-desktop is-12-tablet" style={{ paddingTop: '0' }}>
                            {values.relationTypes.map((type, index) => {
                                if (index >= (values.relationTypes.length / 2)) {
                                    return this.renderRelationTypeCheckBox(values.relationTypes, type, setFieldValue, values)
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    changeValue = (fieldName, setFieldValue, values, value) => {
        const dateFields = ['historicalFrom', 'historicalTo'];

        if (dateFields.includes(fieldName)) {
            let date = moment(value, "DD.MM.YYYY");
            if (date.isValid()) {
                date = date.format("YYYY-MM-DD");
                setFieldValue(fieldName, date);
                this.setFilterAfterChange(fieldName, values, date);
            }
        } else {
            setFieldValue(fieldName, value);
            this.setFilterAfterChange(fieldName, values, value);
        }
    }

    renderRelationTypeCheckBox = (relationTypes, type, setFieldValue, values) => {
        return <BbCheckbox
            key={type.value}
            id={`relationsType-${type.value}-checkbox`}
            label={type.label}
            value={type.checked}
            onChange={(value) => this.checkSingle(relationTypes, type.value, values, value, setFieldValue)}
        />
    }

    onSubmit(values) {
        const params = this.getRelationFilter(values);
        this.props.setRelationsFilter(params);

        this.props.resetDiagramParams();
        const queryParams = {
            hist: params.historicalChecked,
            from: params.historicalFrom,
            to: params.historicalTo,
            level: params.level,
            timeout: params.time,
            rt: params.relationTypes.filter(x => x.checked === true).map((r) => { return r.value }),
            mode: params.mode
        }
        this.props.history.push({
            pathname: `/relation-chart/${this.props.computedMatch.params.firstEntityId},${this.props.computedMatch.params.secondEntityId}?${createQs(queryParams)}`,
            state: { ...params }
        });
    }

    canGoBack() {
        return this.props.rsa[searchInstances.first].entityId && this.props.rsa[searchInstances.second].entityId;
    }

    canContinue = (values) => {
        const formats = ["YYYY-MM-DD"];
        return (
            (values.historicalChecked) ?
                ((isNullOrUndefined(values.historicalFrom) || values.historicalFrom === "" || moment(values.historicalFrom, formats, true).isValid())
                    && (isNullOrUndefined(values.historicalTo) || values.historicalTo === "" || moment(values.historicalTo, formats, true).isValid())
                ) : true)
            && !isNullOrUndefined(values.level)
            && !isNullOrUndefined(values.time);
        // && (values.relationTypes.filter(relation => relation.checked).length > 0);
    }

    isAllChecked(relationTypes) {
        let checkedCount = relationTypes.filter(x => x.checked).length;
        if (checkedCount === 0) { return false };
        if (checkedCount === relationTypes.length) { return true };
        return null;
    }

    checkAll(relationTypes, values, value, setFieldValue) {
        let rel = Object.assign([], relationTypes);
        rel.forEach(x => x.checked = value);
        setFieldValue('relationTypes', relationTypes);
        this.setFilterAfterChange('relationTypes', values, relationTypes);

    }

    checkSingle(relationTypes, typeValue, values, value, setFieldValue) {
        let rel = Object.assign([], relationTypes);
        rel.find(x => x.value === typeValue).checked = value;
        setFieldValue('relationTypes', relationTypes);
        this.setFilterAfterChange('relationTypes', values, relationTypes);
    }

    setFilterAfterChange = (fieldName, values, value) => {
        values[fieldName] = value;
        this.props.setRelationsFilter(values);
    }
}

export default withLocalize(connect(
    state => { return { ...state.appContext, layout: state.layout, rsa: state.relationsSearch }; },
    dispatch => bindActionCreators(Object.assign({}, relationsSearchActions, chartActions), dispatch),
)(withRouter(RelationsSearchParameters)));




